export default __webpack_public_path__ + "static/media/pin.c6f031c6.svg";